<template>
  <div v-if="oldValue != undefined || newValue != undefined">
    <div class="weui-form-preview__item" :class="changed ? 'text-through' : ''">
      <label class="weui-form-preview__label">{{
        (changed ? "原" : "") + label
      }}</label>
      <slot name="old" v-bind:value="oldValue">
        
        <span class="weui-form-preview__value" v-if="formatDate" v-format="'yyyy-MM-dd'">{{ oldValue }}</span>
        <span class="weui-form-preview__value" v-else><b v-if="oldUnit">{{ oldUnit }}</b>{{ oldValue }}</span>
      </slot>
    </div>
    <div class="weui-form-preview__item text-warning" v-if="changed">
      <label class="weui-form-preview__label">新{{ label }}</label>
      <slot name="new" v-bind:value="newValue">
        <span class="weui-form-preview__value" v-if="formatDate" v-format="'yyyy-MM-dd'">{{ newValue }}</span>
        <span class="weui-form-preview__value" v-else><b v-if="newUnit">{{ newUnit }}</b>{{ newValue }}</span>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    formatDate: Boolean,
    oldValue: [String, Number],
    newValue: [String, Number],
    oldUnit: String,
    newUnit: String,
  },
  computed: {
    changed() {
      return this.oldValue != this.newValue;
    },
  },
};
</script>

<style>
.text-warning .weui-form-preview__label,
.text-warning .weui-form-preview__value {
  color: var(--weui-RED);
}

.text-through .weui-form-preview__label,
.text-through .weui-form-preview__value {
  text-decoration: line-through;
}
</style>